export default "__VITE_ASSET__741e161c__"